import "./IndustryHero.scss";

const IndustryHero = ({ title, subTitle, bgImage }) => {
  return (
    <section className="industry-hero-section">
      <div className="hero-slide">
        <div
          className="slide-bg"
          style={{
            backgroundImage: `url('${bgImage}')`,
          }}
        >
          <div className="hero-container">
            <div className="hero-content-wrapper">
              <div className="hero-left">
                <h1 className="hero-title">{title}</h1>
                <p className="hero-description">{subTitle}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryHero;
